import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const Card = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 20px;
`;

const PileGroupName = styled(Typography)`
  font-size: 20px;
  line-height: 20px;
`;

const pileInfos = {
  noSignal: { color: 'rgb(144, 83, 83)', text: '無訊號' },
  standby: { color: 'rgb(91, 143, 249)', text: '待機中' },
  charging: { color: 'rgb(117,217,165)', text: '充電中' },
  waiting: { color: '#00e1ff', text: '排隊中' },
  OCPPReadyToCharge: { color: '#00e1ff', text: '排隊中' },
};

export { Card, PileGroupName, pileInfos };
